import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import CalendarPage from "@/pages/CalendarPage";

export const Route = createFileRoute("/_app/calendar")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="calendar">
      {/* Catches render-time failures (including the render-loop circuit
          breaker) so the page shows an error instead of a blank tab. */}
      <ErrorBoundary autoRecoverHmr>
        <CalendarPage />
      </ErrorBoundary>
    </ModuleGuard>
  );
}
